export function transliterateUmlauts(str = '') {
	return (
		str
			.replace(/ä/i, 'ae')
			.replace(/ö/i, 'oe')
			.replace(/ü/i, 'ue')
			.replace(/ß/i, 'ss')
	);
}
